// components/TypeCell.js
import {memo} from "react";

const typeConfig = {
    1: {text: 'Наличная', color: '#52c41a'},
    2: {text: 'Безналичная', color: '#1890ff'}
};

export const TypeCell = memo(({type}) => (
    <span style={{
        fontSize: '13px',
        color: typeConfig[type]?.color || '#8c8c8c',
        fontWeight: 500
    }}>
        {typeConfig[type]?.text}
    </span>
));

TypeCell.displayName = 'TypeCell';